export const toggleZendeskVisibility = (zendeskWidgetState) => {
  try {
    globalThis?.zE?.('webWidget', zendeskWidgetState?.show ? 'show' : 'hide');
    if (!zendeskWidgetState?.show) {
      globalThis?.zE?.('webWidget', 'close');
    }
  } catch (e) {
    globalThis?.Sentry?.captureException?.(new Error(e));
  }
};

export const toggleZendeskVerticalOffset = (zendeskWidgetState) => {
  try {
    const offset = `${zendeskWidgetState.verticalOffset || 0}px`;

    globalThis?.zE?.('webWidget', 'updateSettings', {
      webWidget: {
        offset: {
          mobile: { vertical: offset },
          vertical: offset,
        },
      },
    });
  } catch (e) {
    globalThis?.Sentry?.captureException?.(new Error(e));
  }
};
